import Swiper from 'swiper';

class SinglePostsSlider {
	swiper: HTMLElement | null;
	buttonNext: HTMLElement | null;
	buttonPrev: HTMLElement | null;

	constructor() {
		this.swiper = document.querySelector('.post-slider');
		this.buttonNext = document.querySelector('.post-slider-button-next');
		this.buttonPrev = document.querySelector('.post-slider-button-prev');
		this.init();
	}

	init(): void {
		window.addEventListener('load', this.initSwiper.bind(this));
	}

	initSwiper(): void {
		if (this.swiper) {
			new Swiper(this.swiper, {
				slidesPerView: 1.4,
				spaceBetween: 20,
				breakpoints: {
					768: {
						slidesPerView: 3.15,
						spaceBetween: 40,
					},
				},
				navigation: {
					nextEl: this.buttonNext,
					prevEl: this.buttonPrev,
				},
				watchOverflow: true,
			});
		}
	}
}

export default new SinglePostsSlider();
